import script from "./CurrentTimecode.vue?vue&type=script&setup=true&lang=js"
export * from "./CurrentTimecode.vue?vue&type=script&setup=true&lang=js"

import "./CurrentTimecode.vue?vue&type=style&index=0&id=48b8290a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48b8290a"]])

export default __exports__